import { IconX } from "@tabler/icons-react";
import { Link } from "react-router";
import { useState } from "react";
import { useLocation } from "react-router";

const CategoryCanvas = (props: any) => {

    const [openCategoryId, setOpenCategoryId] = useState<number | null>(null);

    const toggleCategory = (id: number) => {
        setOpenCategoryId((prev) => (prev === id ? null : id));
    };


    const location = useLocation();

    const renderSubcategories = (category: any, level: number = 1) => {

        if (!category.children || category.children.length === 0) return null;

        return (
            <ul className="list-unstyled">
                {category.children.map((sub: any) => {
                    const currentSlug = decodeURIComponent(location.pathname.split("/")[2]).toLowerCase();

                    const isActive =
                        currentSlug === sub.slug.toLowerCase();
                    return (
                        <li
                            key={sub.id}
                            style={{ paddingRight: level * 15 }}
                            className="py-2 font-medium-lg px-0"
                        >
                            <Link
                                to="#"
                                onClick={() => props.handleNavigate(sub.slug)}
                                data-bs-dismiss="offcanvas"
                                className={`text-decoration-none d-block ${isActive
                                    ? "active-category "
                                    : level >= 2
                                        ? "text-secondary small"
                                        : "text-dark"
                                    }`}
                            >
                                {sub.name}
                            </Link>

                            {renderSubcategories(sub, level + 1)}
                        </li>
                    );
                })}
            </ul>
        );

    };

    return (
        <div className="offcanvas offcanvas-start w-25" id="offcanvas-menu">
            <div className="offcanvas-header align-items-center justify-content-between">
                <h6 className="card-title h5 fw-bold mb-0">انتخاب دسته بندی</h6>
                <button
                    id="close-canvas"
                    className="bg-white border-0 p-0"
                    data-bs-dismiss="offcanvas"
                >
                    <IconX className="font-medium" />
                </button>
            </div>
            <div className="offcanvas-body">
                <div className="accordion" id="accordionExample">

                    {props.parentCategory?.map((category: any) => (

                        <div className="accordion-item border-0" key={category.id}>

                            <h2 className="accordion-header">

                                <button
                                    className={`accordion-button shadow-none bg-white border-bottom ${openCategoryId === category.id ? "" : "collapsed"}`}
                                    type="button"
                                    onClick={() => toggleCategory(category.id)}
                                >
                                    <img
                                        src={category.icon}
                                        style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                        alt={category.name}
                                        className="me-2 rounded rounded-circle"
                                    />
                                    {category.name}
                                </button>

                            </h2>

                            <div
                                className={`accordion-collapse collapse ${openCategoryId === category.id ? "show" : ""}`}
                            >

                                <div className="accordion-body py-2">

                                    {renderSubcategories(category)}

                                </div>

                            </div>

                        </div>

                    ))}

                </div>
            </div>
        </div>
    );
};

export default CategoryCanvas;
